module.exports = __webpack_public_path__ + "static/img/logo_3.086bbf1.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo_3.png
// module id = 3HvC
// module chunks = 1